module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/5/5-e592a5b84101f419c629494b8899b774.jpg";